import Vue from 'vue';
import types from '../mutation-types';

const state = {
  mineCount: 0,
  unAssignedCount: 0,
  allCount: 0,
};

export const getters = {
  getStats: $state => $state,
};

export const actions = {
  set({ commit }, meta) {
    commit(types.SET_CONV_TAB_META, meta);
  },
  updateOnAssigneeChange({ commit, rootGetters }, { previousAssigneeId, newAssigneeId }) {
    const currentUserId = rootGetters.getCurrentUser?.id;
    const wasAssignedToMe = previousAssigneeId === currentUserId;
    const isAssignedToMe = newAssigneeId === currentUserId;
    const wasUnassigned = !previousAssigneeId;
    const isUnassigned = !newAssigneeId;

    let mineCountDelta = 0;
    let unAssignedCountDelta = 0;

    // Handle mine count changes
    if (!wasAssignedToMe && isAssignedToMe) {
      mineCountDelta = 1;
    } else if (wasAssignedToMe && !isAssignedToMe) {
      mineCountDelta = -1;
    }

    // Handle unassigned count changes
    if (wasUnassigned && !isUnassigned) {
      unAssignedCountDelta = -1;
    } else if (!wasUnassigned && isUnassigned) {
      unAssignedCountDelta = 1;
    }

    if (mineCountDelta !== 0 || unAssignedCountDelta !== 0) {
      commit(types.CONTACT_UPDATE_CONV_TAB_META, { mineCountDelta, unAssignedCountDelta });
    }
  },
};

export const mutations = {
  [types.SET_CONV_TAB_META](
    $state,
    {
      mine_count: mineCount,
      unassigned_count: unAssignedCount,
      all_count: allCount,
    } = {}
  ) {
    // Only update if values are defined numbers to prevent overwriting with undefined
    if (typeof mineCount === 'number') {
      Vue.set($state, 'mineCount', mineCount);
    }
    if (typeof allCount === 'number') {
      Vue.set($state, 'allCount', allCount);
    }
    if (typeof unAssignedCount === 'number') {
      Vue.set($state, 'unAssignedCount', unAssignedCount);
    }
  },
  [types.CONTACT_UPDATE_CONV_TAB_META](
    $state,
    { mineCountDelta = 0, unAssignedCountDelta = 0, allCountDelta = 0 }
  ) {
    Vue.set($state, 'mineCount', Math.max(0, $state.mineCount + mineCountDelta));
    Vue.set($state, 'unAssignedCount', Math.max(0, $state.unAssignedCount + unAssignedCountDelta));
    Vue.set($state, 'allCount', Math.max(0, $state.allCount + allCountDelta));
  },
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};
